import * as React from 'react'

import { hot } from 'react-hot-loader'
import { Switch, Route } from 'react-router'
import { IntlProvider } from 'react-intl'
import { useSelector } from 'react-redux'
import data from '../translations/data'
import styled, {
  ThemeProvider,
  createGlobalStyle,
  css,
} from 'styled-components'

import Notifications from './Notifications'
import Payment from './Payment'
import AppLayout from './Layout'
import { Layout, Spin } from 'antd'
import { OrganizationSelectModal, PrivateRoute } from '@library/react-toolkit'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Messages } from '../translations'

declare module 'styled-components' {
  export interface DefaultTheme {
    colors: {
      bodyBackground: string
      primary: string
      primaryLight: string
      primaryExtraLight: string
      error: string
      secondary: string
      white: string
      light: string
      extraLight: string
      extraDark: string
      dark: string
      darkLight: string
      blue: string
      red: string
    }
    paddingUnit: number
    contentMaxWidth: number
    footerHeight: number
    headerHeight: number
  }
}

const Container = styled(Layout)`
  width: 100%;
  height: 100%;
`

const GlobalStyle = createGlobalStyle`
${css`
  body {
    width: 100%;
    height: calc(100% + ${props => props.theme.footerHeight}px);
  }

  #root {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  *.ant-btn {
    & > *.anticon,
    & > *.ant-btn-loading-icon {
      margin-right: 8px;
    }

    & > *.anticon:last-child {
      margin-right: 0px;
    }
  }

  *.ant-btn.ant-btn-icon-only {
    & > *.anticon,
    & > *.ant-btn-loading-icon {
      margin-right: 0px;
    }
  }

  tr {
    & > th:first-child,
    & > td:first-child {
      padding-left: 24px !important;
    }

    & > th:last-child,
    & > td:last-child {
      padding-right: 24px !important;
    }
  }

  ul.ant-menu-vertical.ant-menu-sub {
    min-width: unset;
    border-radius: 0 0 8px 8px;
    margin-top: -8px;
  }
`}
`

const queryClient = new QueryClient()

const WithTranslations = ({ children }: { children: React.ReactNode }) => {
  const locale = useSelector(s => s.locale)
  const [messages, setMessages] = React.useState<{
    en: Messages
    fr: Messages
  } | null>(null)
  React.useEffect(() => {
    data
      .then(ms => {
        // @ts-ignore
        setMessages(ms)
        console.log(ms)
      })
      .catch(console.error)
  })

  if (!messages) {
    return <Spin spinning />
  }

  return (
    <IntlProvider
      locale={locale}
      messages={messages[locale] as Record<string, string>}
    >
      {children}
    </IntlProvider>
  )
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <WithTranslations>
      <ThemeProvider theme={_theme}>
        <GlobalStyle />
        <Container>
          <Notifications />
          <OrganizationSelectModal />
          <Switch>
            <Route path="/payment/:invoiceID" component={Payment} />
            <PrivateRoute
              component={AppLayout}
              nodeEnv={process.env.NODE_ENV}
            />
            <Route>Loading...</Route>
          </Switch>
        </Container>
      </ThemeProvider>
    </WithTranslations>
  </QueryClientProvider>
)

export default hot(module)(App)
